<template>
  <div class="next-steps">
    <h2 class="my-5 text-center">What can I do with this tool?</h2>

    <div class="row">
      <div class="col-md-5 mb-4">
        <h6 class="mb-3">
          <a href="#">
            <font-awesome-icon icon="link" class="mr-2" />Configure Tenants
          </a>
        </h6>
        <p>This tool provides you an ability to add, modify, configure or deactivate tenants.</p>
      </div>

      <div class="col-md"></div>

      <div class="col-md-5 mb-4">
        <h6 class="mb-3">
          <a href="#">
            <font-awesome-icon icon="link" class="mr-2" />Manage Devices
          </a>
        </h6>
        <p>Manage all devices in one place.</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5 mb-4">
        <h6 class="mb-3">
          <a href="#">
            <font-awesome-icon icon="link" class="mr-2" />Manage Users
          </a>
        </h6>
        <p>Manage Users for all Tenants.</p>
      </div>

      <div class="col-md"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: "HomeContent"
};
</script>
